import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivateFn, CanActivateChildFn } from '@angular/router';
import { Observable, of } from 'rxjs';
import { UserService } from '@services/user.service';
import { mergeMap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class IsAuthenticatedGuardFn  {
    
    constructor(private userService : UserService, private router : Router) {}
    
    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
            var nextRoute = state.url
            return this.userService.isLoggedIn().pipe(
                mergeMap(
                    (loggedIn) => {
                        if (loggedIn) {
                            return of(true)
                        } else {
                            setTimeout(() => {
                                this.router.navigate(['/login'], { queryParams: { 'forwardUrl' : nextRoute } });
                            })
                            return of(false)
                        }
                    }
                )
            );
        }

    canActivateChild(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
            return this.canActivate(route, state)
        }
    
}

export const IsAuthenticatedGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot):Observable<boolean> | Promise<boolean> | boolean => {
    return inject(IsAuthenticatedGuardFn).canActivate(next, state);
  }

  export const IsAuthenticatedGuardChild: CanActivateChildFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot):Observable<boolean> | Promise<boolean> | boolean => {
    return inject(IsAuthenticatedGuardFn).canActivateChild(next, state);
  }

